// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3y24Y","savePackageButton":"ClientWallet_savePackageButton__uWsb7"};